import React from 'react';
import { FormattedMessage } from 'react-intl';
import Questionnaires from '../questionnaires';
import VitalList from '../vital-list';
import ClinicalData from '../clinical-data';
import { SectionTitleSC, VitalSidebarSC } from './vital-sidebar.styled';
import DailyReport from '../../daily-report';
import CovidScoreWidget from '../covid-score';
import BarChartWidgets from '../bar-chart-widgets/bar-chart-widgets';
import BehavioralList from '../behavioral-list';

type TVitalSidebarProps = {
  userId: string;
};

const VitalSidebar: React.FC<TVitalSidebarProps> = ({ userId }: TVitalSidebarProps) => {
  return (
    <VitalSidebarSC>
      <SectionTitleSC>
        <FormattedMessage id="life_id.base_info" />
      </SectionTitleSC>
      <DailyReport />
      {/*TODO: odmazat <BaseInfoList />*/}
      <BarChartWidgets />
      {/* <CovidScoreWidget /> */}
      <Questionnaires userId={userId} />
      <SectionTitleSC>
        <FormattedMessage id="life_id.vital_data" />
      </SectionTitleSC>
      <VitalList />
      <SectionTitleSC>
        <FormattedMessage id="life_id.behavioral_data" />
      </SectionTitleSC>
      <BehavioralList userId={userId} />
      <SectionTitleSC>
        <FormattedMessage id="life_id.clinical_data" />
      </SectionTitleSC>
      <ClinicalData clientId={userId} />
    </VitalSidebarSC>
  );
};

export default React.memo(VitalSidebar);
